<div class="grid-container margin-top">
  <text-loader [run]="organization == null" [text]="'Loading data.. please wait'" [tickType]="'.'" [interval]="1500"></text-loader>
  @if (organization != null) {
    <on-base-organization-documents [organization]="organization"></on-base-organization-documents>
  }
</div>

<!--<div class="grid-container margin-top">
<organization-files [organization]="organization"></organization-files>
</div>-->